import React from 'react';
import { Box, TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { Feature } from '@loyalty/shared-common';
import { QlfFormRow } from '@qualifio/ui-commons';
import { ReferralConfigInput } from '@loyalty/shared-common/gamification-api-client';
import { useLeaverPrompt } from '@qualifio/ui-commons/dist/components/qlf-prompt';
import { useTranslation } from 'react-i18next';
import { Flag } from '../../../shared/Flag';
import { LanguageTabs } from '../../../shared/language-tabs';
import { useFeatures } from '../../../features/FeaturesContext';
import { useProgram } from '../../../loyalty/ProgramContext';

export function ReferralConfigForm() {
  const { t } = useTranslation();
  const { features } = useFeatures();
  const { write: referralWrite } = features[Feature.REFERRAL];
  const { program } = useProgram();

  const {
    formState: { errors, isDirty, isSubmitting },
    control,
  } = useFormContext<ReferralConfigInput>();

  useLeaverPrompt(isDirty || isSubmitting);

  return (
    <LanguageTabs
      languages={program.languages}
      message={t('program.settings.referrals.description')}
      errors={errors?.i18nAttributes}
    >
      {({ language }) => (
        <div key={language}>
          <Controller
            key={language}
            control={control}
            name={`i18nAttributes.${language}.link`}
            render={({ field: { ref, ...field }, fieldState: { error } }) => (
              <QlfFormRow label={t('referral.edition.link')}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Flag language={language} />
                  <TextField
                    {...field}
                    sx={{
                      marginLeft: 2,
                    }}
                    disabled={!referralWrite}
                    error={!!error}
                    helperText={error?.message}
                    placeholder={t('referral.edition.placeholders.link')}
                  />
                </Box>
              </QlfFormRow>
            )}
          />
        </div>
      )}
    </LanguageTabs>
  );
}
